import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { InputStateToken, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { CreateDisbursementRequest, closeOtpModal, disbursalVerifyAction, goBack, navigateToTransaction, needHelp } from "./action";
import _ from "lodash";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getWithdrawTempDate } from "../../../configs/utils";
export const template = (height, isFirstJourney, accountNumber, bankName, disbursalAmount, withdrawalAmount, accountOpeningFee, netDisbursalAmount, expectedTransferDate, remark, monthlyEMIRate, nextEMIDate, totalPrincipalOutStanding, processingFee, gstOnProcessingFee, stampDutyFee, dailyEMI, mobileNumber, nextEMIAmount, monthlyInterestEMI, duration, annualInterestRate, currentOutStanding, interestAccuredNotDue, estimatedInterestTillEndOfCycle, currentLender, tempDate, lienMarkingFee) => ({
    layout: {
        id: ROUTE.CONFIRM_AMOUNT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "confirmAmountScreen",
                type: WIDGET.CONFIRM_AMOUNT,
            },
        ],
    },
    datastore: {
        confirmAmountScreen: {
            height: height,
            isFirstJourney,
            backAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.CONFIRM_AMOUNT,
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.CONFIRM_AMOUNT,
                payload: {}
            },
            otpAction: {
                type: ACTION.WITHDRAW_AMOUNT,
                payload: {
                    accountNumber,
                    disbursalAmount,
                },
                routeId: ROUTE.CONFIRM_AMOUNT,
            },
            action: {
                type: ACTION.RESEND_WITHDRAWAL_OTP,
                payload: {
                    disbursalAmount: disbursalAmount,
                    noOfOtpDigits: 6,
                    isFirstJourney,
                },
                routeId: ROUTE.CONFIRM_AMOUNT,
            },
            navigateToTransaction: {
                type: ACTION.NAVIGATE_TRANSACTION,
                payload: {},
                routeId: ROUTE.CONFIRM_AMOUNT,
            },
            closeOtpModal: {
                type: ACTION.CLOSE_OTP_MODAL,
                payload: {},
                routeId: ROUTE.CONFIRM_AMOUNT,
            },
            charLimit: 6,
            loading: false,
            otpModal: false,
            resendTimer: 15,
            state: InputStateToken.DEFAULT,
            caption: { success: "", error: "" },
            accountNumber,
            bankName,
            disbursalAmount,
            accountFee: accountOpeningFee,
            netDisbursalAmount,
            expectedTimeAndDate: expectedTransferDate,
            processedMessage: remark,
            interestOnlyEmi: monthlyEMIRate,
            nextEmiDate: nextEMIDate,
            totalPrincipalOutstanding: totalPrincipalOutStanding,
            processingFee,
            GST: gstOnProcessingFee,
            stampDutyFee,
            dailyInterestVal: dailyEMI,
            withdrawalAmount,
            mobileNumber,
            nextEMIAmount,
            monthlyInterestEMI,
            duration,
            annualInterestRate,
            currentOutStanding,
            interestAccuredNotDue,
            estimatedInterestTillEndOfCycle,
            currentLender,
            tempDate,
            lienMarkingFee,
        }
    },
});
export const confirmAmountScreenMF = {
    onLoad: async ({ network, instrumentTrack, getHeight }, { withdrawResponse, disbursalAmount, isFirstJourney }) => {
        instrumentTrack('CONFIRM_WITHDRAWAL_AMOUNT_PAGE_VIEWED');
        const user = await SharedPropsService.getUser();
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const response = await network.get(`${api.userProfile}${accountId}`, {
            headers: await getAppHeader(),
        });
        const currentLender = user?.linkedCredits[0]?.lendingPartnerId;
        const tempDate = await getWithdrawTempDate();
        const mobileNumber = user?.linkedBorrowerAccounts[0]?.accountHolderPhoneNumber;
        const accountNumber = _.get(response, "data.bankDetails.accountNumber", null);
        const bankName = _.get(response, "data.bankDetails.bankName", "");
        const accountOpeningFee = withdrawResponse?.accountOpeningFee;
        const netDisbursalAmount = withdrawResponse?.netDisbursalAmount;
        const expectedTransferDate = withdrawResponse?.expectedTransferDate;
        const remark = withdrawResponse?.remark;
        const monthlyEMIRate = withdrawResponse?.monthlyEMIRate;
        const withdrawalAmount = withdrawResponse?.withdrawalAmount;
        const monthlyInterestEMI = withdrawResponse?.monthlyInterestEMI;
        const currentOutStanding = withdrawResponse?.currentOutStanding;
        const nextEMIDate = withdrawResponse?.nextEMIDate;
        const totalPrincipalOutStanding = withdrawResponse?.totalPrincipalOutStanding;
        const processingFee = withdrawResponse?.processingFee;
        const gstOnProcessingFee = withdrawResponse?.gstOnProcessingFee;
        const stampDutyFee = withdrawResponse?.stampDutyFee;
        const dailyEMI = withdrawResponse?.dailyEMI;
        const nextEMIAmount = withdrawResponse?.nextEMIAmount;
        const duration = withdrawResponse?.duration;
        const annualInterestRate = withdrawResponse?.annualInterestRate;
        const estimatedInterestTillEndOfCycle = withdrawResponse?.estimatedInterestTillEndOfCycle;
        const interestAccuredNotDue = withdrawResponse?.interestAccuredNotDue;
        const lienMarkingFee = withdrawResponse?.lienMarkingFee;
        return Promise.resolve(template(getHeight(), isFirstJourney, accountNumber, bankName, disbursalAmount, withdrawalAmount, accountOpeningFee, netDisbursalAmount, expectedTransferDate, remark, monthlyEMIRate, nextEMIDate, totalPrincipalOutStanding, processingFee, gstOnProcessingFee, stampDutyFee, dailyEMI, mobileNumber, nextEMIAmount, monthlyInterestEMI, duration, annualInterestRate, currentOutStanding, interestAccuredNotDue, estimatedInterestTillEndOfCycle, currentLender, tempDate, lienMarkingFee));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.WITHDRAW_AMOUNT]: CreateDisbursementRequest,
        [ACTION.RESEND_WITHDRAWAL_OTP]: disbursalVerifyAction,
        [ACTION.NAVIGATE_TRANSACTION]: navigateToTransaction,
        [ACTION.CLOSE_OTP_MODAL]: closeOtpModal,
    },
};
